import { Paths } from 'shared/routes/paths';

const paths = Object.values(Paths).sort(
  (pathA, pathB) => pathA.length - pathB.length,
);

export type Options = {
  level?: number;
};

export const getPathByString = (str: string, { level }: Options = {}) => {
  const leveledPath = str
    .toLowerCase()
    .split('/')
    .slice(0, level !== undefined ? level + 1 : undefined);
  const exactPath = paths.find((path) => path === leveledPath.join('/'));

  return (
    exactPath ||
    paths.find((path) => {
      const splicedPath = path
        .split('/')
        .slice(0, level !== undefined ? level + 1 : undefined);

      if (splicedPath.length < leveledPath.length) {
        return false;
      }

      return splicedPath
        .slice(0)
        .every((part, i) => part.startsWith(':') || part === leveledPath[i]);
    })
  );
};

export const getPathVariablesByString = (str: string) => {
  const path = getPathByString(str);
  if (!path) {
    return {};
  }

  const splicedPath = path.split('/');
  const variableIndexes = splicedPath.reduce<number[]>(
    (acc, entry, currentIndex) => {
      if (entry.startsWith(':')) {
        acc.push(currentIndex);
      }

      return acc;
    },
    [],
  );

  return str
    .split('/')
    .reduce<Record<string, string>>((acc, entry, currentIndex) => {
      if (variableIndexes.includes(currentIndex)) {
        const variableKey = splicedPath[currentIndex].replace(':', '');
        acc[variableKey] = entry;
      }

      return acc;
    }, {});
};
